const $ = window.jQuery;

$(() => {
    const $tabs = $('[data-tab-slug]');

    if (!$tabs.length) {
        return;
    }

    $tabs.on('click', function() {
        if (!$(this).hasClass('tab-thumb-grid__tab--active')) {
            $('.tab-thumb-grid__tab--active').removeClass(
                'tab-thumb-grid__tab--active',
            );
            $(this).addClass('tab-thumb-grid__tab--active');
            const slug = $(this).attr('data-tab-slug');
            const $active = $(
                '.tab-thumb-grid__thumbs.tab-thumb-grid__thumbs--active',
            );
            $active
                .addClass('animated fadeOutUp')
                .one('animationend', function() {
                    $active.removeClass(
                        'animated fadeOutUp tab-thumb-grid__thumbs--active',
                    );
                    const $new_active = $(
                        `.tab-thumb-grid__thumbs[data-tab="${slug}"]`,
                    );
                    $new_active.addClass(
                        'animated fadeInUp tab-thumb-grid__thumbs--active',
                    );
                    $new_active.one('animationend', () => {
                        $new_active.removeClass('animated fadeInUp');
                    });
                });
        }
    });
});
